/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/drafts/anneal.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/drafts/anneal.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/anneal.mdx';

const metadata = {
  slug: "anneal",
  title: "Anneal: Why I'm Building a Rust-Native Extension Host for VSCode",
  author: "Christian Battaglia",
  description: "Every IDE makes you choose: ecosystem or performance. Anneal is a Rust-native VSCode extension host that runs existing JS extensions on embedded V8 with pre-compiled bytecode, supports native Rust extensions through the same interface, and ships with local-first AI. This is the manifesto — why open source, why the VSIX ecosystem, why local-first, and why the GUI vs TUI debate misses the point.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  
  date: "2026-03-01T00:00:00.000Z",
  
  readTime: "50 min read",
  tags: ["Rust","V8","VSCode","IDE","extensions","Anneal","developer tools","open source","AI","local-first","Kreuzberg","sqlite-vec","OpenCode","Claude Code","Cursor"],
};

export const Route = createFileRoute('/blog/posts/anneal')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/anneal',
    image: '/og/blog/anneal.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
